<template>
    <el-pagination
        :current-page="search.page"
        :page-size="search.size"
        :total="total"
        @current-change="changeCurrent"
        background
        layout="total, prev, pager, next, jumper"
    />
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('site');

export default {
    computed: {
        ...mapState({
            total: state => state.total,
            search: state => state.search,
        }),
    },
    methods: {
        ...mapActions(['changeSearch']),
        changeCurrent(page) {
            this.changeSearch({ page });
        },
    },
};
</script>
